import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a4913c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "end-game-screen__banner",
  ref: "end_screen_vfx"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/",
  class: "lobby-btn"
}, " Retour à l'accueil ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["end-game-screen", { 'end-game-screen--show': _ctx.hasResult }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["end-game-screen__content", 'end-game-screen__content--' + _ctx.won ? 'victory' : 'defeat'])
    }, [
      _createElementVNode("div", _hoisted_1, null, 512),
      (_ctx.spectator_mode)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.winner) + " remporte le duel !", 1))
        : _createCommentVNode("", true),
      _hoisted_3
    ], 2)
  ], 2))
}